import { camelizeStyleName } from './utils/camelizeStyleName';
import { hyphenateStyleName } from './utils/hyphenateStyleName';

export const getStyle = (node: Element, property?: string) => {
  if (property) {
    //@ts-ignore
    const value = (node as HTMLElement).style[camelizeStyleName(property)];

    if (value) {
      return value;
    }

    const styles = getComputedStyle(node);

    if (styles) {
      return styles.getPropertyValue(hyphenateStyleName(property));
    }
  }

  return (node as HTMLElement).style || getComputedStyle(node);
}